module.exports = __webpack_public_path__ + "img/61800.2ebbea2b.jpg";